import Register from "./auth/Register.vue";
import Login from "./auth/Login.vue";
import Forgot from "./auth/Forgot.vue";
import Reset from "./auth/Reset.vue";
import Vue from 'vue';

$("#register").each(function () {
  new (Vue.extend(Register))().$mount(this);
});

$("#login").each(function () {
  new (Vue.extend(Login))().$mount(this);
});

$("#forgot-password").each(function () {
  new (Vue.extend(Forgot))().$mount(this);
});

$("#reset-password").each(function () {
  new (Vue.extend(Reset))().$mount(this);
});
